"use client";

import React, { useContext } from 'react';
import Button from '../../button';
import { ModalContext } from '../context';
const NormalCancelBtn = () => {
  const {
    cancelButtonProps,
    cancelTextLocale,
    onCancel
  } = useContext(ModalContext);
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    onClick: onCancel
  }, cancelButtonProps), cancelTextLocale);
};
export default NormalCancelBtn;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/modal/components/NormalCancelBtn.js
// module id = 3555
// module chunks = 0